import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_84csx48g4t: FaireBrandEntity = {
  token: "b_84csx48g4t",
  type: "brand",
  name: "Center Court",
  avatarUrl:
    "https://cdn.faire.com/fastly/54425a66662f6f3d5af30de6d67e8f272db1e529c09f0a9ee9fb6e89e890d489.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5ddc875c6bb65f1dd28034a5c950d4bb742e21d708f71b94ec7f73d652cddaad.png",
  logoUrl:
    "https://cdn.faire.com/fastly/54425a66662f6f3d5af30de6d67e8f272db1e529c09f0a9ee9fb6e89e890d489.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5ddc875c6bb65f1dd28034a5c950d4bb742e21d708f71b94ec7f73d652cddaad.png",
  location: "South Bend, IN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "For over 25 years, Center Court has specialized in one-of-a-kind jewelry and has offered a wide array of jewelry lines with affordable price points and profitable margins. Many of our lines are consistently ranked as top-performers in GiftBeat Magazine.\n\nWe are a one-stop-shop; whether you are looking for necklaces, bracelets, earrings or rings, we have you covered! We pride ourselves in offering free top-of-the-line displayers with every Starter Package. Our displayers not only capture attention, but perfectly showcase your products. Sell our jewelry with confidence by knowing we offer a lifetime warranty. \n\nOur customers would say we are best known for having fast shipping and a hassle-free customer service team. We value our partnerships with our retailers and always aim for 100% customer satisfaction.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:56.234Z",
    importedBy: "entity-db-cli",
  },
};
